export const GET_ADD_PROPERTY_OWNER_LISTINGS_REQUEST = "GET_ADD_PROPERTY_OWNER_LISTINGS_REQUEST";
export const GET_ADD_PROPERTY_OWNER_LISTINGS_SUCCESS = "GET_ADD_PROPERTY_OWNER_LISTINGS_SUCCESS";
export const GET_ADD_PROPERTY_OWNER_LISTINGS_FAIL = "GET_ADD_PROPERTY_OWNER_LISTINGS_FAIL";

export const ADD_PROPERTY_OWNER_REQUEST = "ADD_PROPERTY_OWNER_REQUEST";
export const ADD_PROPERTY_OWNER_SUCCESS = "ADD_PROPERTY_OWNER_SUCCESS";
export const ADD_PROPERTY_OWNER_FAIL = "ADD_PROPERTY_OWNER_FAIL";

export const GET_PROPERTY_OWNERS_REQUEST = "GET_PROPERTY_OWNERS_REQUEST";
export const GET_PROPERTY_OWNERS_SUCCESS = "GET_PROPERTY_OWNERS_SUCCESS";
export const GET_PROPERTY_OWNERS_FAIL = "GET_PROPERTY_OWNERS_FAIL";

export const EDIT_PROPERTY_OWNER_REQUEST = "EDIT_PROPERTY_OWNER_REQUEST";
export const EDIT_PROPERTY_OWNER_SUCCESS = "EDIT_PROPERTY_OWNER_SUCCESS";
export const EDIT_PROPERTY_OWNER_FAIL = "EDIT_PROPERTY_OWNER_FAIL";

export const DELETE_PROPERTY_OWNER_REQUEST = "DELETE_PROPERTY_OWNER_REQUEST";
export const DELETE_PROPERTY_OWNER_SUCCESS = "DELETE_PROPERTY_OWNER_SUCCESS";
export const DELETE_PROPERTY_OWNER_FAIL = "DELETE_PROPERTY_OWNER_FAIL";
